import React from 'react';
import useWindowSize from 'utils/hooks/useWindowSize';
import Image from 'next/image';

import contact_1 from '../../../../../public/images/main/logisticsFinance/contact/1.webp';

const ContactUs = () => {
  const { width } = useWindowSize();

  return (
    <section className="contact-us">
      <div className="container">
        <Image
          sizes="100vw"
          style={{
            width: '100%',
            height: 'auto',
          }}
          className="contact-us__vector"
          src={contact_1}
          alt="vector"
        />

        <div className="contact-us__texts">
          <div className="title">Contact us</div>
          <div className="text">
            For further information or to {width <= 768 && width > 568 && <br />} speak {width > 768 && <br />}
            to a member of {width > 568 && width <= 768 && <br />} DP World {width <= 568 && <br />} Trade Finance
          </div>
        </div>
        <div className="contact-us__info">
          <div className="card1">
            <strong>Team call</strong> +97148259090
          </div>
          <div className="card2">
            <strong>Email Global </strong> global.tradefinance@dpworld.com
          </div>
          <div className="card3">
            <strong>Email UAE </strong> uae.tradefinance@dpworld.com
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
